import { yupResolver } from '@hookform/resolvers/yup';
import React, { useMemo, useState , useEffect } from 'react'
import { useForm } from 'react-hook-form';
import * as Yup from 'yup'
import { FormInput } from '../../wrappers/formInput';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import UploadFiled from "../../components/fileduploader";
import Button from "../../components/button";
import FormHead from "../../components/headings/FromHead";
import Styles from "./styles.module.scss";
import { postAPI, uploadApi } from '../../api';
import { Error } from '@progress/kendo-react-labels';
import { skillNameConverter } from '../../utils/EllowUtils';
import { REACT_APP_CANDIDATE_FREELANCER } from '../../utils/common';

export type ServicesOfferingFormFields  = {
    services: string;
    domain: string;
    technologyArea: string;
    supportingDocument: string;
}

interface Props {
    clickHandler?: any,
    defaultValues?: any,
    customerId?: any,
    defImage?: any,
    companyName?: any,
    back?: any,
    disable?: boolean;
    providerDomains?: any;
    skillsList: any;
    jobRolesList: any;
    customer_metadata?: any;
}

const ServicesOffering : React.FC<Props> = ({
    clickHandler,
    defaultValues,
    customerId,
    defImage,
    companyName,
    back,
    providerDomains,
    disable,
    jobRolesList,
    skillsList,
    customer_metadata
    
}) => {
 
  const validationSchema = Yup.object({
    technologyArea: Yup.array().required("Field is required")
})
  
const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues]),
  };

const { 
    register, 
    handleSubmit, 
    control, 
    watch,
    setValue,  
    formState: { errors }, 
} = useForm<ServicesOfferingFormFields>(formOptions)

const { v4: uuidv4 } = require("uuid");
const [error, setError] = useState<boolean>(false)
const [message, setMessage] = useState<string>('')
const handleChange =(e:any , name: string) => {

  }
  
  useEffect(() => {
    if (watch().technologyArea) {
      setMessage('')
      setError(false)
   }
  }, [watch])

useEffect(() => {
  
  if(defaultValues){
      setValue('services', defaultValues.jobRoles)
      setValue('domain', defaultValues.domains)
      setValue('technologyArea', defaultValues.skills)
      setValue('supportingDocument', defaultValues.supportingDoc)
  }else{
    let skills = customer_metadata && customer_metadata.skills && customer_metadata.skills.map((item: any) => { return({skillId: item.id , skillName: item.name})}) 
    setValue('services', customer_metadata.services)
    setValue('domain', customer_metadata.domains)
    setValue('technologyArea', skills)
  }
 // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [defaultValues])


  const uploadFile = (e: any) => {
    let fileExtension = e.target.files[0].name.split(".").pop();
    if (fileExtension === "pdf" || fileExtension === "doc" || fileExtension === "docx") {
      let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");
      let file = e.target.files[0]
      let type = file.type
    
      let value = {
        "action":"putObject",
        "filename":fileName
      }
    
      postAPI( REACT_APP_CANDIDATE_FREELANCER + '/resume-signed-url', value).then((data) => {    
        let signedUrl = data.url;    
        uploadApi(signedUrl, file, type).then((response) => {
          setValue('supportingDocument', fileName.slice(36, fileName.length))
        }
        )
      })
    }
  }

  const submitValues = (data: any) => {
    let body =  {
        "customerId": customerId,
        "customerMetadata": {
          "servicesAndOfferings": {
            "skills": data.technologyArea,
            "jobRoles": data.services,
            "domains": data.domain,
            "supportingDoc": data.supportingDocument
  
          }
        }
    } 
    if (data.technologyArea && data.technologyArea.length < 1) {
      setMessage("Field is required")
      setError(true)
    }
    else {
      clickHandler(body) 
    }
  }
  
return (
    <>
    <form>
        <div className="form-group">
          <figure className={Styles.uploadPicWrap}>
            {defImage ? <img alt='' src={defImage} /> :
            <span className={Styles.noPicWrap}>{companyName && companyName[0]}{companyName && companyName[1]}</span>}   
          </figure>
            <FormHead>Services & Offering</FormHead>
            <label className="lablel">Identify the services your firm offers</label>
            <MultiDropDownInput<ServicesOfferingFormFields>
              control={control}
              data={jobRolesList}
              name="services"
              register={register}
              onChange={(e: any) => handleChange(e, "skills")}
              textField="name"
              dataItemKey="id"
              errors={errors}
            />
        </div>
        <div className="form-group">
          <label className="lablel">Identify your focused domains</label>
          <MultiDropDownInput<ServicesOfferingFormFields>
            control={control}
            data={providerDomains}
            name="domain"
            register={register}
            onChange={(e: any) => handleChange(e, "domain")}
            textField="name"
            dataItemKey="id"
            errors={errors}
          />
        </div>
        <div className="form-group">
          <label className="lablel">Identify your Technology capability areas</label>
          <MultiDropDownInput<ServicesOfferingFormFields>
            control={control}
            data={skillsList && skillsList.length > 0 && skillNameConverter(skillsList)}
            name="technologyArea"
            register={register}
            onChange={(e: any) => handleChange(e, "technologyArea")}
            textField="skillName"
            dataItemKey="skillId"
            errors={errors}
        />
                      {error && <Error>{message}</Error>}
        </div>
        <div className="form-group">
          <label className="lablel">Upload Supporting Document</label>
          <div className="uploadWrap">
            <FormInput<ServicesOfferingFormFields>
              id="supportingDocument"
              type="text"
              name="supportingDocument"
              placeholder="Upload documents"
              register={register}
              errors={errors}
              disabled={true}
            />
            <UploadFiled uploadFile={uploadFile} />
          </div>
        </div> 
        <div className="action-form">
          <Button onClick={back} variant="cancel">Back</Button>
          <Button disabled={disable} onClick={handleSubmit(submitValues)} variant="primary">Save</Button>
        </div>      
    </form>
    </>
  )
}
export default ServicesOffering 